export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/Parser.worker.ecba2c47.worker.js");
}
